import HomePage from "./pages/home-page";
import "./index.css";

function App() {
	return (
		<div className="App">
			<HomePage />
		</div>
	);
}

export default App;
